import { Box, Link, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { executeAgent } from '../../../../../store/slices/reviews';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import ReviewActonLog from '../factModals/reviewActionLog';
import { uTCtoLocalforTime } from '../../../../../common/utils';

const ReviewAgentDetails = ({ data }) => {
  const theme = useTheme();
  
   const {
      ReviewerName: {
         ReviewerName = '',
         Recommendation = '',
         "Determined First Name": determinedFirstName = '',
         Reasoning = ''
         } = {},
         RunOn = '',
         RequestId = ''
        } = data || {}; // Default to empty object if `data` is undefined

   
   // Memoize the table data
   const tableData = useMemo(() => {
      return [{
         reviewerName: ReviewerName,
         recommendation: Recommendation,
         determinedFirstName: determinedFirstName,
         reasoning: Reasoning,
         requestId: RequestId
      }];
   }, [ReviewerName, Recommendation, determinedFirstName, Reasoning, RunOn, RequestId]);


   const Ircolumns = useMemo(() => [
      { header: 'Reviewer Name', accessorKey: 'reviewerName', width: 60 },
      {
         header: 'Determined First Name',
         accessorKey: 'determinedFirstName',
         Cell: ({ row }) => row?.original['determinedFirstName']
            ? row?.original['determinedFirstName']
            : <Typography fontStyle={'italic'}>{'(None)'}</Typography>
      },
   ], []);

   const columns = useMemo(() => [
      { header: 'Reviewer Name', accessorKey: 'reviewerName', width: 60 },
      { header: 'Determined First Name', accessorKey: 'determinedFirstName' },
   ], []);

   const table = useMaterialReactTable({
      columns: Ircolumns || columns,
      data: tableData,
      enableFullScreenToggle: false,
      enableDensityToggle: false,
      enableColumnFilters: false,
      enableTopToolbar: false,
      enableBottomToolbar: false,
      enableSorting: false,
      enableHiding: false,
      enableColumnActions: false,
      muiTableContainerProps: {
         sx: {
            maxHeight: 'unset',
            backgroundColor: theme.palette.background.paper,
            overflow: 'hidden'
         }
      },
      muiTablePaperProps: {
         className: "std_table review-requests",
         sx: { boxShadow: 'none', backgroundColor: theme.palette.background.paper }
      },
      muiTableBodyCellProps: {
         sx: { border: 'none', backgroundColor: theme.palette.background.paper }
      }
   });

   return (
      <>
     
      <Stack spacing={2}>
         {tableData.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
               No data available
            </Typography>
         ) : (
            <MaterialReactTable table={table} sx={{ "& thead tr": { boxShadow: "none" } }} />
         )}

          <Stack sx={{ paddingBottom: '15px' }}>
           <Typography sx={{ color: '#1976d2', paddingBottom: '10px' }}>Reasoning</Typography>
            {tableData.map((item, index) => (
            <Typography key={index} variant="body2">
            {item.reasoning || '(No Reasoning Available)'}
          </Typography>
        
        ))}
      </Stack>
      </Stack>
                              
     
      </>
      
   );
};

export default ReviewAgentDetails;


